module.exports = __webpack_public_path__ + "img/Economic,Social & Cultural Rights.7fcc88df.svg";